var render = function render(){
  var _this = this;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "process-content protocol-editor"
  }, [_c('ProcessTop'), _c('article', {
    staticClass: "protocolControl"
  }, [_c('div', {
    staticClass: "tabWrap",
    class: {
      wikiActive: _vm.typeChecked === 'wiki'
    }
  }, [_vm._l(_vm.tabInfo, function (_ref) {
    var label = _ref.label,
        type = _ref.type;
    return !_vm.initChecked && !_vm.emptyProtocol ? [type === 'tree' || type === 'wiki' && _vm.PROCESS_INFO.protocols && _vm.PROCESS_INFO.protocols.length !== 0 ? _c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.typeChecked,
        expression: "typeChecked"
      }],
      attrs: {
        "type": "radio",
        "id": type,
        "name": "protocolTab"
      },
      domProps: {
        "value": type,
        "checked": _vm._q(_vm.typeChecked, type)
      },
      on: {
        "change": function ($event) {
          _vm.typeChecked = type;
        }
      }
    }), _c('span', {
      attrs: {
        "for": type
      }
    }, [_vm._v(_vm._s(label))])]) : _vm._e()] : _vm._e();
  })], 2), !_vm.manageMode ? _c('DocumentOption', {
    attrs: {
      "apiType": "protocol"
    }
  }) : _vm._e(), _vm.manageMode ? _c('ProtocolReadOnlyDocumentOption', {
    attrs: {
      "isAuth": _vm.isAuth,
      "apiType": "protocol",
      "protocolType": _vm.protocolType
    }
  }) : _vm._e(), _vm.typeChecked == 'tree' ? _c('Editor', {
    key: _vm.componentKey,
    ref: "editor",
    attrs: {
      "treeMode": _vm.treeMode,
      "firstBln": _vm.firstBln,
      "editKey": _vm.editKey
    },
    on: {
      "updateNode": _vm.updateList,
      "change": function (mode) {
        return _vm.modeChange(mode);
      },
      "mount": function (info) {
        _vm.editorInfo = info;
      },
      "linkNodeSetCheck": function (data) {
        return _this.PublishPopupObj.nodeSetComplete = data;
      },
      "forceRerender": _vm.forceRerender
    }
  }) : _vm._e(), _vm.typeChecked == 'wiki' ? _c('Wiki', {
    attrs: {
      "readonly": _vm.treeMode === 'readonly'
    },
    on: {
      "change": function ($event) {
        _vm.typeChecked = 'tree';
      }
    }
  }) : _vm._e(), _c('Loading', {
    attrs: {
      "visible": _vm.loading
    }
  }), !_vm.initChecked && !_vm.emptyProtocol && _vm.treeMode != 'readonly' && !_vm.manageMode ? _c('editor-btm-option', {
    staticClass: "protocolBtmBar",
    attrs: {
      "openLogListPopup": _vm.openLogListPopup,
      "openSaveLogPopup": _vm.openSaveLogPopup,
      "openPublishPopup": _vm.openPublishPopup,
      "protocolType": _vm.protocolType
    },
    on: {
      "searchProcessNode": _vm.searchProcessNode,
      "endEditProtocol": _vm.endEditProtocol,
      "saveRequest": _vm.saveDiagram
    }
  }) : _vm._e(), _vm.manageMode ? _c('ProtocolReadOnlyBtmOption', {
    class: {
      protocolReadBar: _vm.isAuth
    },
    attrs: {
      "isAuth": _vm.isAuth,
      "connectProtocolData": _vm.connectProtocolData,
      "openUtilizeListPopup": _vm.openUtilizeListPopup,
      "protocolType": _vm.protocolType
    },
    on: {
      "editOriginProtocol": _vm.setEditFlag
    }
  }) : _vm._e(), _c('ProcessPreview', {
    attrs: {
      "process-info": _vm.selectProcessInfo
    },
    on: {
      "setMethod": function ($event) {
        return _vm.getChildMethods('preview', $event);
      },
      "preview-close": _vm.searchPopupShow
    }
  }), _c('ProcessNodeSearch', {
    attrs: {
      "type": 'process'
    },
    on: {
      "setMethod": function ($event) {
        return _vm.getChildMethods('search', $event);
      },
      "select-process": _vm.selectProcess,
      "process-preview": _vm.previewClick
    }
  })], 1), _vm.status.wikiPreviewerStatus.visible ? _c('div', {
    staticClass: "wikiViewerPopup"
  }, [_c('div', {
    staticClass: "layerWrap"
  }, [_c('h2', [_vm._v("위키 미리보기")]), _c('WikiViewer', {
    attrs: {
      "Data": _vm.status.wikiPreviewerStatus
    }
  }), _c('button', {
    staticClass: "close",
    on: {
      "click": function ($event) {
        _vm.status.wikiPreviewerStatus = false;
      }
    }
  }, [_vm._v("닫기")])], 1)]) : _vm._e(), _c('SaveLogPopup', {
    attrs: {
      "crntObj": _vm.SaveLogPopupObj
    }
  }), _c('LogListPopup', {
    attrs: {
      "crntObj": _vm.LogListPopupObj
    }
  }), _c('releasePopup', {
    attrs: {
      "openFlag": _vm.PublishPopupObj.openBln
    },
    on: {
      "update:openFlag": function ($event) {
        return _vm.$set(_vm.PublishPopupObj, "openBln", $event);
      },
      "update:open-flag": function ($event) {
        return _vm.$set(_vm.PublishPopupObj, "openBln", $event);
      },
      "saveDiagram": _vm.saveDiagram
    }
  }), _c('UtilizeListPopup', {
    attrs: {
      "crntObj": _vm.UtilizeListPopupObj
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }